<div class="ui-log-card ui-log-card--{{ uiLogType }}">
  <div class="ui-log-card__preview">
    @if (showSerialNumber) {
      <h4 class="pointer">
        <span class="blue" (click)="terminalUiLogs(uiLog.serialNumber)">{{ uiLog.serialNumber }}</span>
      </h4>
    }
    @if (showUpdated) {
      <div class="updated">
        {{ uiLog.updated | date: 'medium' }}<br />
        State: {{ uiLog.state }}
      </div>
    }
    @if (!uiLog.uiElement) {
      <div class="ui-log-card__bezel pointer no-ui" (click)="terminalEmulator(uiLog.serialNumber)">
        <p>Terminalen er formentlig blank lige nu.</p>
        <p>Send en kommando til skærmen vha. terminalstyring.</p>
      </div>
    }
    @if (uiLog.uiElement) {
      @let uiElement = uiLog.uiElement;
      <div class="ui-log-card__bezel pointer" (click)="terminalEmulator(uiLog.serialNumber)" [class]="uiElement.background">
        @if (uiLogType === 'info') {
          <div class="ui-log-card__qr">
            <img src="/assets/img/payter-imgs/gfx-ok-dk-qr-code.png" alt="qr kode" />
          </div>
        }
        @if (uiLogType !== 'info') {
          <div class="ui-log-card__logo"><img src="/assets/img/payter-imgs/ok-img-logo.png" alt="OK a.m.b.a" /></div>
        }
        @if (uiLog) {
          <div class="ui-log-card__title">{{ uiElement.properties.title }}</div>
          <div class="ui-log-card__subtitle">{{ uiElement.properties.subtitle }}</div>
          @if (uiElement.message) {
            <div class="ui-log-card__card">
              {{ uiElement.message }}
            </div>
          }
          <div class="ui-log-card__btn-list">
            @for (selectionItem of uiElement.selectionItems; track selectionItem) {
              <button class="ui-log-card__button ui-log-card__button--plug" disabled="true" title="Brug knapper på terminalen">
                @if (selectionItem.icon) {
                  <span class="ui-log-card__button-icon" [class]="selectionItem.icon"></span>
                }
                {{ selectionItem.label }}
              </button>
            }
          </div>
          <div class="ui-log-card__bottom-actions">
            @if (uiElement.startButton) {
              <button class="ui-log-card__button" disabled="true" title="Brug knapper på terminalen">
                {{ uiElement.startButton.label }}
              </button>
            }
            @if (uiElement.backButton) {
              <button class="ui-log-card__button" disabled="true" title="Brug knapper på terminalen">
                {{ uiElement.backButton.label }}
              </button>
            }
          </div>
        }
      </div>
    }
  </div>
  @for (location of uiLog.locations; track $index) {
    <div class="ui-log-card__info-icons">
      <a
        [routerLink]="['/ok-app-emulator']"
        [matTooltip]="location.name + ', ' + location?.formattedAddress + ' - Vis i OK-app emulator'"
        [queryParams]="{
          mapSearchInputType: 'location',
          query: location?.chargingStationLocationIdentifier,
        }"
        target="_blank">
        <mat-icon>travel_explore</mat-icon>
      </a>
      @for (chargingStationIdentifier of location?.chargingStationIdentifiers; track chargingStationIdentifier) {
        <a
          [routerLink]="['/ok-app-emulator']"
          [queryParams]="{
            mapSearchInputType: 'chargingStationIdentifier',
            query: chargingStationIdentifier,
          }"
          [matTooltip]="'Vis ' + chargingStationIdentifier + ' i OK-app emulator'"
          target="_blank">
          <mat-icon svgIcon="charger_outlined"></mat-icon>
        </a>
      }
      <a
        class="cursor-pointer"
        target="_blank"
        (click)="terminalConnectorRelation(uiLog.serialNumber)"
        [matTooltip]="location?.stationNumbers.length + ' tilknyttede lade - klik for at ændre'">
        <mat-icon [style]="'width:24px; height:24px'" svgIcon="socket_type2"></mat-icon>
      </a>
      @for (stationNumber of location?.stationNumbers; track stationNumber) {
        <div class="ui-log-card__charger-number cursor-help" [matTooltip]="'Ladepunkt ID: ' + stationNumber">
          {{ stationNumber }}
        </div>
      }
    </div>
  }
</div>
